module.exports = __webpack_public_path__ + "audio-937ff3e7e0f8.m4a";